const addClass = (element, classname) => {
    element.classList.add(classname)
}

const removeClass = (element, classname) => {
    if (Array.isArray(element)) {
        element.map(el => removeClass(el, classname))
        return;
    }

    element.classList.remove(classname)
}

const toggleClass = (element, classname) => {
    element.classList.toggle(classname)
}

export {addClass, removeClass, toggleClass}
